import ModalController from "../modal_controller"
import PackageController from "../venue/package_controller"

export default class extends ModalController {
  static outlets = ["venue-package"]
  declare readonly venuePackageOutlet: PackageController

  bookPackage(): void {
    this.close()

    this.venuePackageOutlet.bookButtonClick()
  }

  buyPackageVoucher(): void {
    this.close()

    this.venuePackageOutlet.voucherButtonClick()
  }
}
